<template>
  <div>
    <v-navigation-drawer
      :value="isDrawerOpen"
      app
      floating
      width="310"
      class="app-navigation-menu"
      :right="$vuetify.rtl"
      @input="val => $emit('update:is-drawer-open', val)"
    >
      <!-- Navigation Header -->
      <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
        <router-link to="/" class="d-flex align-center text-decoration-none">
          <v-img
            :src="require('@/assets/images/logos/main-logo.jpg')"
            max-height="250px"
            max-width="250px"
            alt="logo"
            contain
            eager
            class="app-logo me-3"
          ></v-img>
        </router-link>
      </div>

      <!-- Navigation Items -->
      <v-list expand shaped class="vertical-nav-menu-items pr-5">
        <nav-menu-link v-if="position === 'OFFICER'" title="Dashboard" :to="{ name: 'dashboard' }"
                       :icon="icons.mdiHomeOutline"></nav-menu-link>
        <nav-menu-link
          v-if="position === 'OFFICER'"
          title="Order"
          :to="{ name: 'new-order-dine-in' }"
          :icon="icons.mdiBankTransfer"
        ></nav-menu-link>
        <nav-menu-link
          v-if="position === 'OFFICER'"
          title="Additional Order"
          :to="{ name: 'add-new-order-dine-in' }"
          :icon="icons.mdiBankTransfer"
        ></nav-menu-link>
        <nav-menu-section-title
          v-if="position === 'ADMIN' || position === 'ADMIN SPECIAL'"
          title="ADMIN INTERFACE"
        ></nav-menu-section-title>
        <nav-menu-link
          v-if="position === 'ADMIN' || position === 'ADMIN SPECIAL'"
          title="Register Branch"
          :to="{ name: 'admin-register-branch' }"
        ></nav-menu-link>
        <nav-menu-link
          v-if="position === 'OFFICER'"
          title="Register Customer"
          :to="{ name: 'register-customer' }"
          :icon="icons.mdiAccountBoxMultiple"
        ></nav-menu-link>
        <nav-menu-link
          v-if="position === 'ADMIN' || position === 'ADMIN SPECIAL'"
          title="Register User"
          :to="{ name: 'admin-register-users' }"
        ></nav-menu-link>
        <nav-menu-link
          v-if="position === 'ADMIN' || position === 'ADMIN SPECIAL'"
          title="Register Service"
          :to="{ name: 'admin-register-menu' }"
        ></nav-menu-link>

        <nav-menu-group  v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="LOAN INTERFACE"
                        :icon="icons.mdiCash100">
          <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="New Loan"
                         :to="{ name: 'new-loan' }"></nav-menu-link>
          <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title=" Loan Payment"
                         :to="{ name: 'loan-payment' }"></nav-menu-link>
          <nav-menu-group class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="Report"
                          :icon="icons.mdiCashMultiple">
            <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="List of All Deductions Report"
                           :to="{ name: 'list-of-deductions-loans' }"></nav-menu-link>
            <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="Monthly Deduction Report"
                           :to="{ name: 'monthly-deductions-loan' }"></nav-menu-link>
            <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'"
                           title="Monthly Summary Deduction Report"
                           :to="{ name: 'monthly-summary-deductions-loan' }"></nav-menu-link>
            <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="Monthly Due Report"
                           :to="{ name: 'monthly-due-loan' }"></nav-menu-link>
            <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'"
                           title="Monthly Collection Report"
                           :to="{ name: 'monthly-collection-loan' }"></nav-menu-link>
            <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'"
                           title="Delinquent Accounts Report"
                           :to="{ name: 'delinquent-account-loan' }"></nav-menu-link>
            <nav-menu-link class="ml-3" v-if="position === 'OFFICER' ||position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="List of Approved Loan"
                           :to="{ name: 'list-of-loan' }"></nav-menu-link>
            <nav-menu-link class="ml-3" v-if="position === 'ADMIN' || position === 'ADMIN SPECIAL'" title="List of Pending Loan"
                           :to="{ name: 'list-of-pending-loan' }"></nav-menu-link>
          </nav-menu-group>
        </nav-menu-group>

        <nav-menu-link title="Search Customer"
                       :to="{ name: 'search-info' }" :icon="icons.mdiSearchWeb"></nav-menu-link>
        <nav-menu-section-title
          v-if="position === 'OFFICER'"
          title="CASHIER INTERFACE"
        ></nav-menu-section-title>
        <!--      Liquidations-->
        <!--        <nav-menu-link v-if="position === 'OFFICER'" title="Fund Request"-->
        <!--                       :icon="icons.mdiAccountCash"-->
        <!--                       :to="{ name: 'fund-request' }"></nav-menu-link>-->
        <!--        <nav-menu-link v-if="position === 'OFFICER'" title="CorePortal Transaction"-->
        <!--                       :icon="icons.mdiCashLock"-->
        <!--                       :to="{ name: 'fund-liquidations' }"></nav-menu-link>-->
        <nav-menu-link v-if="position === 'OFFICER'" title="Client Payment"
                       :icon="icons.mdiCash100"
                       :to="{ name: 'client-payment' }"></nav-menu-link>
        <nav-menu-link v-if="position === 'OFFICER'" title="Deposit Slip"
                       :icon="icons.mdiCash100"
                       :to="{ name: 'deposit-liquidations' }"></nav-menu-link>
        <!--      Liquidations End-->
      </v-list>
      <nav-menu-section-title
        title="VIEW INTERFACE"
      ></nav-menu-section-title>
      <nav-menu-link title="Deposit Slips Data"
                     v-if="position === 'OFFICER' || position === 'ADMIN' || position === 'ADMIN SPECIAL'"
                     :icon="icons.mdiFileOutline"
                     :to="{ name: 'deposit-slips-data' }"></nav-menu-link>
      <nav-menu-link v-if="position === 'ADMIN' || position === 'ADMIN SPECIAL'"
                     title="Bank Transaction Summary"
                     :icon="icons.mdiBankTransfer"
                     :to="{ name: 'bank-transaction-summary' }"></nav-menu-link>
      <nav-menu-section-title
        title="REPORT INTERFACE"
      ></nav-menu-section-title>
      <nav-menu-link
        v-if="position === 'OFFICER' || position === 'ADMIN' || position === 'ADMIN SPECIAL'"
        title="List of Customers"
        :icon="icons.mdiPointOfSale"
        :to="{ name: 'list-of-customers' }"></nav-menu-link>
      <nav-menu-link
        v-if="position === 'OFFICER' || position === 'ADMIN' || position === 'ADMIN SPECIAL'"
        title="Travel Order Summary"
        :icon="icons.mdiPointOfSale"
        :to="{ name: 'travel-order-summary' }"></nav-menu-link>
      <nav-menu-link
        v-if="position === 'OFFICER' || position === 'ADMIN' || position === 'ADMIN SPECIAL'"
        title="Service Summary"
        :icon="icons.mdiSale"
        :to="{ name: 'service-summary' }"></nav-menu-link>
    </v-navigation-drawer>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiPencilOutline,
  mdiAccountSearchOutline,
  mdiForum,
  mdiCashMultiple,
  mdiBankTransfer,
  mdiAccountBoxMultiple,
  mdiSearchWeb,
  mdiSale,
  mdiPointOfSale,
  mdiReceipt,
  mdiPaperRollOutline,
  mdiCash100,
  mdiBank,
  mdiCashLock,
  mdiPhonePlus,
  mdiCreditCardCheck,
  mdiHumanQueue,
  mdiHumanCapacityIncrease,
  mdiChartMultiline,
  mdiChartTimeline,
  mdiCashRemove,
  mdiShoePrint,
  mdiCurrencyPhp,
  mdiFormatListText,
  mdiClipboardListOutline,
  mdiMonitorDashboard,
  mdiBookOpenVariant,
  mdiAccountCash,
  mdiChartBar,
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'
import {mapGetters} from 'vuex'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
  },
  computed: {
    ...mapGetters('authentication', ['position']),
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiSearchWeb,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiPencilOutline,
        mdiAccountSearchOutline,
        mdiForum,
        mdiCashMultiple,
        mdiBankTransfer,
        mdiAccountBoxMultiple,
        mdiSale,
        mdiPointOfSale,
        mdiReceipt,
        mdiPaperRollOutline,
        mdiCash100,
        mdiBank,
        mdiCashLock,
        mdiPhonePlus,
        mdiCreditCardCheck,
        mdiHumanQueue,
        mdiHumanCapacityIncrease,
        mdiChartMultiline,
        mdiChartTimeline,
        mdiCashRemove,
        mdiShoePrint,
        mdiCurrencyPhp,
        mdiFormatListText,
        mdiClipboardListOutline,
        mdiMonitorDashboard,
        mdiBookOpenVariant,
        mdiAccountCash,
        mdiChartBar,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;

  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
